var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email-verify-completed my-5 d-flex align-items-center justify-content-between"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t('verification.verifyEmail'))+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"far fa-check"})])
}]

export { render, staticRenderFns }